import React, { useEffect } from "react";
import Header from "../components/Header";
import "./css/PrivacyPolicy.css";
import Footer from "../components/Footer";

export default function RefundPolicy() {
	useEffect(() => {

	}, []);

	return (
		<div className="App">
			<Header />
			<div className="container">
				<div className="row">
					<div className="col-12">
						<div className="policyMainArea">
							<h1>Return, Refund & Cancellation Policy</h1>
							<p><strong>Effective Date:</strong> 9th May 2023</p>
							<p>This Return, Refund & Cancellation Policy (“Policy”) governs all purchases and service engagements made with Rupin Consultancy.</p>
							
							<h2>Company Details</h2>
							<p>
								<strong>Rupin Consultancy</strong><br />
								📍 Anita Kunj, Sitabpur Talla, Kotdwara, Pauri Garhwal, Uttarakhand, 246149<br />
								📧 Email: info@rupin.ai
							</p>
							<p>By engaging with our services or purchasing our products, you agree to the terms of this Policy.</p>

							<h2>1. Nature of Business</h2>
							<p>Rupin Consultancy provides consultancy services, digital solutions, and may supply customized or standard products. Due to the customized and service-oriented nature of our offerings, refund eligibility is limited and subject to the terms below.</p>

							<h2>2. Services – No Refund After Delivery</h2>
							<p>Consultancy, digital, and professional services are non-returnable and non-refundable once delivered or commenced.</p>
							<p>By confirming an order, the client acknowledges and agrees that:</p>
							<ul>
								<li>The service is customized based on client requirements</li>
								<li>Refunds are not applicable once work has started</li>
							</ul>
							<p>However, if a service has not yet commenced, cancellation may be considered subject to deductions (see Section 4).</p>

							<h2>3. Product Returns (If Applicable)</h2>
							<p>For any physical products supplied:</p>
							<ul>
								<li>Return requests must be raised within 7 days of delivery</li>
								<li>The product must be:
									<ul>
										<li>Unused, undamaged, and in original condition</li>
										<li>Returned with original packaging, invoice, and accessories</li>
									</ul>
								</li>
							</ul>
							<h3>Non-Returnable Cases</h3>
							<ul>
								<li>Customized or made-to-order products</li>
								<li>Installed or used products</li>
								<li>Products damaged due to improper handling by the customer</li>
								<li>Products without original packaging</li>
							</ul>

							<h2>4. Cancellation Policy</h2>
							<p>Orders/services can be canceled before commencement or dispatch.</p>
							<p>In such cases:</p>
							<ul>
								<li>A processing fee (up to 20%) may be deducted</li>
								<li>Any third-party costs already incurred will be deducted</li>
							</ul>
							<p>Once:</p>
							<ul>
								<li>Service has commenced OR</li>
								<li>Product has been dispatched</li>
							</ul>
							<p>👉 Cancellation requests may be rejected or partially approved at our sole discretion.</p>

							<h2>5. Refund Policy</h2>
							<ul>
								<li>Approved refunds will be processed within 7–10 business days</li>
								<li>Refunds will be issued to the original payment method only</li>
							</ul>
							<p>Rupin Consultancy shall not be liable for:</p>
							<ul>
								<li>Delays caused by banks/payment gateways</li>
								<li>Incorrect payment details provided by the customer</li>
							</ul>

							<h2>6. GST & Taxation Clause (Important)</h2>
							<p>All invoices are issued in compliance with Indian GST laws.</p>
							<p>Once an invoice is generated:</p>
							<ul>
								<li>GST component is non-refundable except where legally required</li>
							</ul>
							<p>Any refund processed will be:</p>
							<ul>
								<li>Adjusted against applicable GST regulations</li>
								<li>Subject to issuance of credit notes where applicable</li>
							</ul>

							<h2>7. Limitation of Liability</h2>
							<p>Rupin Consultancy shall not be liable for:</p>
							<ul>
								<li>Indirect, incidental, or consequential damages</li>
								<li>Loss of business, revenue, or data</li>
							</ul>
							<p>Our total liability shall not exceed the amount paid by the customer for the specific service/product.</p>

							<h2>8. Force Majeure</h2>
							<p>We shall not be held responsible for failure or delay in performance due to events beyond our control, including but not limited to:</p>
							<ul>
								<li>Natural disasters</li>
								<li>Government restrictions</li>
								<li>Internet or technical failures</li>
								<li>Supply chain disruptions</li>
							</ul>

							<h2>9. Dispute Resolution & Jurisdiction</h2>
							<ul>
								<li>Any disputes arising shall be subject to the jurisdiction of courts located in Pauri Garhwal, Uttarakhand, India</li>
								<li>Parties agree to attempt amicable resolution before initiating legal proceedings</li>
							</ul>

							<h2>10. Consumer Protection Compliance</h2>
							<p>This policy is framed in accordance with:</p>
							<ul>
								<li>The Consumer Protection Act, 2019</li>
								<li>Applicable E-commerce Rules (if applicable)</li>
							</ul>
							<p>Nothing in this Policy shall override statutory consumer rights available under Indian law.</p>

							<h2>11. Fraud Prevention Clause</h2>
							<p>Rupin Consultancy reserves the right to:</p>
							<ul>
								<li>Refuse returns or refunds if fraud or misuse is suspected</li>
								<li>Verify customer identity before processing refunds</li>
							</ul>

							<h2>12. Policy Updates</h2>
							<p>We reserve the right to modify this Policy at any time. Updates will be effective immediately upon posting on our website.</p>

							<h2>13. Contact for Support</h2>
							<p>For any requests related to returns, refunds, or cancellations:</p>
							<ul>
								<li>📧 Email: info@rupin.ai</li>
								<li>📍 Address: Anita Kunj, Sitabpur Talla, Kotdwara, Pauri Garhwal, Uttarakhand, 246149</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
}
